import React from "react";
import AppLayout from "@/components/Layouts/AppLayout";
import HeroBloveToken from "@/components/HeroBloveToken/HeroBloveToken";
import AboutBloveToken from "@/components/AboutBloveToken/AboutBloveToken";
import AboutLoveWallet from "@/components/AboutLoveWallet/AboutLoveWallet";
import AboutXchangeOn from "@/components/AboutXchangeOn/AboutXchangeOn";
import AboutDexa from "@/components/AboutDexa/AboutDexa";
import SupplyBurn from "@/components/Supply Burn/SupplyBurn";
import Head from "next/head";

const bloveToken = () => {
  return (
    <AppLayout>
      <Head>
        <title>
          B-Love Token is a community-reward token for BLove Network.
        </title>
        <meta
          name='description'
          content='The supply of B-Love tokens will be controlled by a burning mechanism.
Each month, 10% of the initial supply will be burned.'
        />
        <link rel='icon' href='/assets/Image/blove_favicon.png' />
      </Head>
      <HeroBloveToken />
      <AboutBloveToken />
      <AboutLoveWallet />
      <AboutXchangeOn />
      <AboutDexa />
      <SupplyBurn />
    </AppLayout>
  )
};

export default bloveToken;
